"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockVerpackungTrommel_MAT0178542 = exports.mockZwischenbodenIa_421_50 = exports.mockFlatIa_56_3_1 = exports.mockFlatIa_418 = exports.mockFlatIa_413 = exports.mockAe_4000_20_2_2_A = exports.mockAe_4000_20_2_1_A = exports.mockKette_400_20_135_0 = exports.mockKette_B17_2_063 = exports.mockUniversalbodenIa_E6_29__2310_050 = exports.mockUniversalbodenIa_E6_29__2310_025 = exports.mockFachbodenIa_E6_29__2210_33 = exports.mockFachbodenIa_E6_29__2210_23 = exports.mockFachbodenIa_E6_29__2210_18 = exports.mockEinsteckbodenIa_E6_29 = exports.mockSmallEinsteckbodenIa_E6_29 = exports.mockSeitenplatteIa_E6_29_13 = exports.mockRoundIa_E6_29__29_1_1 = exports.mockFlatIa_E6_29_12 = exports.mockFlatIa_E6_29_11_R = exports.mockFlatIa_E6_29_11 = exports.mockFlatIa_E4_56 = exports.mockFreieLeitung4mm = exports.mockMotorleitung = exports.mockDatenleitung = exports.mockSteuerleitung2 = exports.mockSteuerleitung = exports.mockAE2_E6_29 = exports.mockAE_E6_29 = exports.mockKetteE6_29 = exports.mockAE2_E4_56 = exports.mockAE_E4_56 = exports.mockKetteE6_80L_15_150 = exports.mockKetteE6_80L_10_150 = exports.mockKetteE4_56_12_150 = exports.mockKetteR4_56 = exports.mockKetteH4_56 = exports.mockKetteE4_56 = void 0;
const ArticleSpecs_1 = require("./ArticleSpecs");
const LeitungCategory_1 = require("./leitung/LeitungCategory");
const TrommelModel_1 = require("./verpackung/TrommelModel");
const VerpackungModel_1 = require("./verpackung/VerpackungModel");
exports.mockKetteE4_56 = {
    EchainSystem: 'E4_light',
    SerieRef: { Kuerzel: 'E4.56', Id: 40507 },
    FreitragenderBetriebErlaubt: true,
    K2: { Value: 610, Unit: 'mm' },
    MinDistO: { Value: 16, Unit: 'mm' },
    MinDistU: { Value: 16, Unit: 'mm' },
    GewichtKgProM: { Value: 3.93, Unit: 'kg_m' },
    MinDistKlemmO: { Value: 16, Unit: 'mm' },
    Aussenbreite: { Value: 134, Unit: 'mm' },
    Teilung: { Value: 91, Unit: 'mm' },
    MinDistKlemmU: { Value: 16, Unit: 'mm' },
    ArtSerieBreite: 'E4.56.10',
    IndexBreite: '10',
    LeitungDiameterMax: { Value: 50, Unit: 'mm' },
    StandardTrennstegArtNr: '56.1.1',
    Innenbreite: { Value: 100, Unit: 'mm' },
    IndexBiegeradius: '135',
    K: { Value: 610, Unit: 'mm' },
    Aussenhoehe: { Value: 84, Unit: 'mm' },
    Biegeradius: { Value: 135, Unit: 'mm' },
    RastPosDist: { Value: 5, Unit: 'mm' },
    ArtNr: { DE: 'E4.56.10.135.0', US: 'E4-56-10-135-0' },
    UngeradeAnzahlGlieder: false,
    GleitenderBetriebErlaubt: true,
    Id: 40857,
    Innenhoehe: { Value: 56, Unit: 'mm' },
    VersatzFestpunktErlaubt: true,
    Bezeichnung: {
        'de-DE': 'e-kette® Serie E4.56',
        'hu-HU': 'E-Chain® E4.56 széria',
        'en-US': 'E-Chains® Series E4-56',
        'zh-TW': '拖鏈E4.56系列',
        'ko-KR': 'E-Chain® E4.56 시리즈',
        'es-ES': 'Cadenas portacables de la Serie E4.56',
        'zh-CN': '拖链E4.56系列',
        'it-IT': 'Catena portacavi Serie E4.56',
        'pl-PL': 'E-Chain® Seria E4.56',
        'nl-NL': 'Kabelrups Series E4.56',
        'pt-PT': 'Calhas articuladas Série E4.56',
        'sv-SE': 'E-kedja serie E4.56',
        'da-DK': 'E-Kæde-serie E4.56',
        'cs-CZ': 'e-chain® série E4.56',
        'fr-FR': 'Chaîne Porte-Câbles Série E4.56',
        'en-GB': 'e-chain® Series E4.56',
        'ja-JP': 'エナジーチェーン E4.56型',
    },
};
exports.mockKetteH4_56 = {
    EchainSystem: 'E4_light',
    SerieRef: { Kuerzel: 'H4.56', Id: 40507 },
    FreitragenderBetriebErlaubt: true,
    K2: { Value: 610, Unit: 'mm' },
    MinDistO: { Value: 16, Unit: 'mm' },
    MinDistU: { Value: 16, Unit: 'mm' },
    GewichtKgProM: { Value: 3.93, Unit: 'kg_m' },
    MinDistKlemmO: { Value: 16, Unit: 'mm' },
    Aussenbreite: { Value: 134, Unit: 'mm' },
    Teilung: { Value: 91, Unit: 'mm' },
    MinDistKlemmU: { Value: 16, Unit: 'mm' },
    ArtSerieBreite: 'H4.56.10',
    IndexBreite: '10',
    LeitungDiameterMax: { Value: 50, Unit: 'mm' },
    StandardTrennstegArtNr: '56.1.1',
    Innenbreite: { Value: 100, Unit: 'mm' },
    IndexBiegeradius: '135',
    K: { Value: 610, Unit: 'mm' },
    Aussenhoehe: { Value: 84, Unit: 'mm' },
    Biegeradius: { Value: 135, Unit: 'mm' },
    RastPosDist: { Value: 5, Unit: 'mm' },
    ArtNr: { DE: 'H4.56.10.135.0', US: 'H4-56-10-135-0' },
    UngeradeAnzahlGlieder: false,
    GleitenderBetriebErlaubt: true,
    Id: 40857,
    Innenhoehe: { Value: 56, Unit: 'mm' },
    VersatzFestpunktErlaubt: true,
    Bezeichnung: {
        'de-DE': 'e-kette® Serie H4.56',
        'hu-HU': 'E-Chain® H4.56 széria',
        'en-US': 'E-Chains® Series H4-56',
        'zh-TW': '拖鏈H4.56系列',
        'ko-KR': 'E-Chain® H4.56 시리즈',
        'es-ES': 'Cadenas portacables de la Serie H4.56',
        'zh-CN': '拖链H4.56系列',
        'it-IT': 'Catena portacavi Serie H4.56',
        'pl-PL': 'E-Chain® Seria H4.56',
        'nl-NL': 'Kabelrups Series H4.56',
        'pt-PT': 'Calhas articuladas Série H4.56',
        'sv-SE': 'E-kedja serie H4.56',
        'da-DK': 'E-Kæde-serie H4.56',
        'cs-CZ': 'e-chain® série H4.56',
        'fr-FR': 'Chaîne Porte-Câbles Série H4.56',
        'en-GB': 'e-chain® Series H4.56',
        'ja-JP': 'エナジーチェーン H4.56型',
    },
    Halbstegig: true,
};
exports.mockKetteR4_56 = {
    EchainSystem: 'E4_light',
    SerieRef: { Kuerzel: 'R4.56', Id: 40507 },
    FreitragenderBetriebErlaubt: true,
    K2: { Value: 610, Unit: 'mm' },
    MinDistO: { Value: 16, Unit: 'mm' },
    MinDistU: { Value: 16, Unit: 'mm' },
    GewichtKgProM: { Value: 3.93, Unit: 'kg_m' },
    MinDistKlemmO: { Value: 16, Unit: 'mm' },
    Aussenbreite: { Value: 134, Unit: 'mm' },
    Teilung: { Value: 91, Unit: 'mm' },
    MinDistKlemmU: { Value: 16, Unit: 'mm' },
    ArtSerieBreite: 'R4.56.10',
    IndexBreite: '10',
    LeitungDiameterMax: { Value: 50, Unit: 'mm' },
    StandardTrennstegArtNr: '56.1.1',
    Innenbreite: { Value: 100, Unit: 'mm' },
    IndexBiegeradius: '135',
    K: { Value: 610, Unit: 'mm' },
    Aussenhoehe: { Value: 84, Unit: 'mm' },
    Biegeradius: { Value: 135, Unit: 'mm' },
    RastPosDist: { Value: 5, Unit: 'mm' },
    ArtNr: { DE: 'R4.56.10.135.0', US: 'R4-56-10-135-0' },
    UngeradeAnzahlGlieder: false,
    GleitenderBetriebErlaubt: true,
    Id: 40857,
    Innenhoehe: { Value: 56, Unit: 'mm' },
    VersatzFestpunktErlaubt: true,
    Bezeichnung: {
        'de-DE': 'e-kette® Serie R4.56',
        'hu-HU': 'E-Chain® R4.56 széria',
        'en-US': 'E-Chains® Series R4-56',
        'zh-TW': '拖鏈R4.56系列',
        'ko-KR': 'E-Chain® R4.56 시리즈',
        'es-ES': 'Cadenas portacables de la Serie R4.56',
        'zh-CN': '拖链R4.56系列',
        'it-IT': 'Catena portacavi Serie R4.56',
        'pl-PL': 'E-Chain® Seria R4.56',
        'nl-NL': 'Kabelrups Series R4.56',
        'pt-PT': 'Calhas articuladas Série R4.56',
        'sv-SE': 'E-kedja serie R4.56',
        'da-DK': 'E-Kæde-serie R4.56',
        'cs-CZ': 'e-chain® série R4.56',
        'fr-FR': 'Chaîne Porte-Câbles Série R4.56',
        'en-GB': 'e-chain® Series R4.56',
        'ja-JP': 'エナジーチェーン R4.56型',
    },
    Halbstegig: false,
};
exports.mockKetteE4_56_12_150 = {
    EchainSystem: 'E4_1',
    SerieRef: { Kuerzel: 'E4.56', Id: 40507 },
    FreitragenderBetriebErlaubt: true,
    K2: { Value: 819, Unit: 'mm' },
    MinDistO: { Value: 16, Unit: 'mm' },
    MinDistU: { Value: 16, Unit: 'mm' },
    GewichtKgProM: { Value: 4.13, Unit: 'kg_m' },
    MinDistKlemmO: { Value: 16, Unit: 'mm' },
    Aussenbreite: { Value: 159, Unit: 'mm' },
    Teilung: { Value: 91, Unit: 'mm' },
    MinDistKlemmU: { Value: 16, Unit: 'mm' },
    ArtSerieBreite: 'E4.56.12',
    IndexBreite: '12',
    LeitungDiameterMax: { Value: 50, Unit: 'mm' },
    StandardTrennstegArtNr: '56.1.1',
    Innenbreite: { Value: 125, Unit: 'mm' },
    IndexBiegeradius: '150',
    K: { Value: 655, Unit: 'mm' },
    Aussenhoehe: { Value: 84, Unit: 'mm' },
    Biegeradius: { Value: 150, Unit: 'mm' },
    RastPosDist: { Value: 5, Unit: 'mm' },
    ArtNr: { DE: 'E4.56.12.150.0', US: 'E4-56-12-150-0' },
    UngeradeAnzahlGlieder: false,
    GleitenderBetriebErlaubt: true,
    Id: 40878,
    Innenhoehe: { Value: 56, Unit: 'mm' },
    VersatzFestpunktErlaubt: true,
    Bezeichnung: {
        'de-DE': 'e-kette® Serie E4.56',
        'hu-HU': 'E-Chain® E4.56 széria',
        'en-US': 'E-Chains® Series E4-56',
        'zh-TW': '拖鏈E4.56系列',
        'ko-KR': 'E-Chain® E4.56 시리즈',
        'es-ES': 'Cadenas portacables de la Serie E4.56',
        'zh-CN': '拖链E4.56系列',
        'it-IT': 'Catena portacavi Serie E4.56',
        'pl-PL': 'E-Chain® Seria E4.56',
        'nl-NL': 'Kabelrups Series E4.56',
        'pt-PT': 'Calhas articuladas Série E4.56',
        'sv-SE': 'E-kedja serie E4.56',
        'da-DK': 'E-Kæde-serie E4.56',
        'cs-CZ': 'e-chain® série E4.56',
        'fr-FR': 'Chaîne Porte-Câbles Série E4.56',
        'en-GB': 'e-chain® Series E4.56',
        'ja-JP': 'エナジーチェーン E4.56型',
    },
};
exports.mockKetteE6_80L_10_150 = {
    EchainSystem: 'E6',
    SerieRef: { Kuerzel: 'E6.80L', Id: 32265 },
    FreitragenderBetriebErlaubt: true,
    MinDistO: { Value: 15, Unit: 'mm' },
    MinDistU: { Value: 15, Unit: 'mm' },
    GewichtKgProM: { Value: 3.33, Unit: 'kg_m' },
    MinDistKlemmO: { Value: 0, Unit: 'mm' },
    Aussenbreite: { Value: 128, Unit: 'mm' },
    Teilung: { Value: 65, Unit: 'mm' },
    MinDistKlemmU: { Value: 0, Unit: 'mm' },
    ArtSerieBreite: 'E6.80L.10',
    IndexBreite: '10',
    LeitungDiameterMax: { Value: 72, Unit: 'mm' },
    StandardTrennstegArtNr: '80.1.1',
    Innenbreite: { Value: 100, Unit: 'mm' },
    IndexBiegeradius: '150',
    K: { Value: 605, Unit: 'mm' },
    Aussenhoehe: { Value: 108, Unit: 'mm' },
    Biegeradius: { Value: 150, Unit: 'mm' },
    RastPosDist: { Value: 5, Unit: 'mm' },
    ArtNr: { DE: 'E6.80L.10.150.0', US: 'E6-80L-10-150-0' },
    UngeradeAnzahlGlieder: false,
    GleitenderBetriebErlaubt: false,
    Id: 35570,
    Innenhoehe: { Value: 80, Unit: 'mm' },
    VersatzFestpunktErlaubt: true,
    Bezeichnung: {
        'de-DE': 'e-kette® Serie E6.80L',
        'hu-HU': 'e-chain® Széria E6.80L',
        'en-US': 'Energy chain® Series E6.80L',
        'zh-TW': 'E6.80L系列拖鏈',
        'ko-KR': 'E-Chain® E6.80L 시리즈',
        'es-ES': 'Cadena portacable E-Chain®, Series E6.80L',
        'zh-CN': 'E6.80L系列拖链',
        'it-IT': 'Catena portacavi serie E6.80L',
        'pl-PL': 'e-prowadniki serii E6.80L',
        'nl-NL': 'Kabelrups serie E6.80L',
        'pt-PT': 'Calhas articuladas da série E6.80L',
        'sv-SE': 'E-kedja serie E6.80L',
        'da-DK': 'E-Kæde Serie E6.80L',
        'cs-CZ': 'e-chain® Série E6.80L',
        'fr-FR': 'Chaîne Porte-Câbles Série E6.80L',
        'en-GB': 'e-chain® Series E6.80L',
        'ja-JP': 'エナジーチェーン E6.80L型',
    },
};
exports.mockKetteE6_80L_15_150 = {
    EchainSystem: 'E6',
    SerieRef: { Kuerzel: 'E6.80L', Id: 32265 },
    FreitragenderBetriebErlaubt: true,
    MinDistO: { Value: 15, Unit: 'mm' },
    MinDistU: { Value: 15, Unit: 'mm' },
    GewichtKgProM: { Value: 3.55, Unit: 'kg_m' },
    MinDistKlemmO: { Value: 0, Unit: 'mm' },
    Aussenbreite: { Value: 178, Unit: 'mm' },
    Teilung: { Value: 65, Unit: 'mm' },
    MinDistKlemmU: { Value: 0, Unit: 'mm' },
    ArtSerieBreite: 'E6.80L.15',
    IndexBreite: '15',
    LeitungDiameterMax: { Value: 72, Unit: 'mm' },
    StandardTrennstegArtNr: '80.1.1',
    Innenbreite: { Value: 150, Unit: 'mm' },
    IndexBiegeradius: '150',
    K: { Value: 605, Unit: 'mm' },
    Aussenhoehe: { Value: 108, Unit: 'mm' },
    Biegeradius: { Value: 150, Unit: 'mm' },
    RastPosDist: { Value: 5, Unit: 'mm' },
    ArtNr: { DE: 'E6.80L.15.150.0', US: 'E6-80L-15-150-0' },
    UngeradeAnzahlGlieder: false,
    GleitenderBetriebErlaubt: false,
    Id: 35648,
    Innenhoehe: { Value: 80, Unit: 'mm' },
    VersatzFestpunktErlaubt: true,
    Bezeichnung: {
        'de-DE': 'e-kette® Serie E6.80L',
        'hu-HU': 'e-chain® Széria E6.80L',
        'en-US': 'Energy chain® Series E6.80L',
        'zh-TW': 'E6.80L系列拖鏈',
        'ko-KR': 'E-Chain® E6.80L 시리즈',
        'es-ES': 'Cadena portacable E-Chain®, Series E6.80L',
        'zh-CN': 'E6.80L系列拖链',
        'it-IT': 'Catena portacavi serie E6.80L',
        'pl-PL': 'e-prowadniki serii E6.80L',
        'nl-NL': 'Kabelrups serie E6.80L',
        'pt-PT': 'Calhas articuladas da série E6.80L',
        'sv-SE': 'E-kedja serie E6.80L',
        'da-DK': 'E-Kæde Serie E6.80L',
        'cs-CZ': 'e-chain® Série E6.80L',
        'fr-FR': 'Chaîne Porte-Câbles Série E6.80L',
        'en-GB': 'e-chain® Series E6.80L',
        'ja-JP': 'エナジーチェーン E6.80L型',
    },
};
exports.mockAE_E4_56 = {
    ArtNr: { DE: 'E4.561.15.2.2.C.A' },
    Mitnehmer: true,
    Id: 48930131300,
    Montiert: true,
    GliedAnzahlAbhaengig: 2,
    Festpunkt: false,
};
exports.mockAE2_E4_56 = {
    ArtNr: { DE: 'E4.561.15.2.1.C.A' },
    Mitnehmer: false,
    Id: 151901787300,
    Montiert: true,
    GliedAnzahlAbhaengig: 2,
    Festpunkt: true,
};
exports.mockKetteE6_29 = {
    EchainSystem: 'E6_1',
    SerieRef: { Kuerzel: 'E6.29', Id: 26577 },
    FreitragenderBetriebErlaubt: true,
    MinDistO: { Value: 12, Unit: 'mm' },
    MinDistU: { Value: 12, Unit: 'mm' },
    GewichtKgProM: { Value: 0.9, Unit: 'kg_m' },
    MinDistKlemmO: { Value: 12, Unit: 'mm' },
    Aussenbreite: { Value: 116, Unit: 'mm' },
    Teilung: { Value: 22, Unit: 'mm' },
    MinDistKlemmU: { Value: 12, Unit: 'mm' },
    ArtSerieBreite: 'E6.29.100',
    IndexBreite: '100',
    LeitungDiameterMax: { Value: 25, Unit: 'mm' },
    StandardTrennstegArtNr: 'E6.29.11',
    Innenbreite: { Value: 100, Unit: 'mm' },
    IndexBiegeradius: '100',
    K: { Value: 360, Unit: 'mm' },
    Aussenhoehe: { Value: 35, Unit: 'mm' },
    Biegeradius: { Value: 100, Unit: 'mm' },
    RastPosDist: { Value: 2, Unit: 'mm' },
    ArtNr: { DE: 'E6.29.100.100.0', US: 'E6-29-100-100-0' },
    UngeradeAnzahlGlieder: false,
    GleitenderBetriebErlaubt: true,
    Id: 26609,
    Innenhoehe: { Value: 29, Unit: 'mm' },
    VersatzFestpunktErlaubt: true,
    Bezeichnung: {
        'de-DE': 'e-kette® Serie E6.29',
        'hu-HU': 'E-Chain® E6.29 széria',
        'en-US': 'E-Chain® Series E6-29 ',
        'zh-TW': '拖鏈E6.29系列',
        'ko-KR': 'E-Chain® E6.29 시리즈',
        'es-ES': 'Cadenas portacables de la Serie E6.29',
        'zh-CN': '拖链E6.29系列',
        'it-IT': 'Catena portacavi Serie E6.29',
        'pl-PL': 'E-Chain® Seria E6.29',
        'nl-NL': 'Kabelrups Series E6.29',
        'pt-PT': 'Calhas articuladas Série E6.29',
        'sv-SE': 'E-kedja serie E6.29',
        'da-DK': 'E-Kæde-serie E6.29',
        'cs-CZ': 'e-chain® série E6.29',
        'fr-FR': 'Chaîne Porte-Câbles Série E6.29',
        'en-GB': 'e-chain® Series E6.29',
        'ja-JP': 'エナジーチェーン E6.29型',
    },
};
exports.mockAE_E6_29 = {
    ArtNr: { DE: 'E6.290.100.2.A' },
    Mitnehmer: true,
    Id: 272640864200,
    Montiert: true,
    GliedAnzahlAbhaengig: 0,
    Festpunkt: false,
};
exports.mockAE2_E6_29 = {
    ArtNr: { DE: 'E6.290.100.1.A' },
    Mitnehmer: false,
    Id: 269740021900,
    Montiert: true,
    GliedAnzahlAbhaengig: 0,
    Festpunkt: true,
};
exports.mockSteuerleitung = {
    Aussendurchmesser: { Value: 11, Unit: 'mm' },
    GewichtKgProKm: { Value: 182, Unit: 'kg_km' },
    RAL_Nummer: '7001',
    FesteLaenge: false,
    ArtNr: { DE: 'CF140.10.07.UL', US: 'CF140-10-07-UL' },
    Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
    MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
    ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    Leitungsaufbau: { 'de-DE': '(7G1,0)C' },
    Id: 32957,
    BiegeradiusMin: { Value: 82.5, Unit: 'mm' },
    Kupferzahl: { Value: 110, Unit: 'kg_km' },
    Bezeichnung: {
        'de-DE': 'chainflex® CF140.UL Steuerleitung PVC',
        'hu-HU': 'chainflex® CF140.D PVC vezérlőkábel',
        'en-US': 'chainflex® CF140.UL control cable PVC',
        'zh-TW': 'chainflex® CF140.UL高柔性控制電纜PVC',
        'ko-KR': 'Chainflex® CF140.UL 제어 케이블 PVC',
        'es-ES': 'chainflex® CF140.UL cable de control PVC',
        'zh-CN': 'chainflex® CF140.UL高柔性控制电缆PVC',
        'it-IT': 'Cavo di comando chainflex® CF140.UL in PVC',
        'pl-PL': 'Przewód sterowania chainflex® CF140.UL PVC',
        'nl-NL': 'chainflex® CF140.UL stuurstroomkabel PVC',
        'pt-PT': 'Cabo de comando chainflex® CF140.UL em PVC',
        'sv-SE': 'chainflex® CF140.UL styrkabel PVC',
        'da-DK': 'chainflex® CF140.UL PVC-styrekabel',
        'cs-CZ': 'Ovládací kabel chainflex® CF140.UL, PVC',
        'fr-FR': 'Câble de commandes PVC chainflex® CF140.UL',
        'en-GB': 'chainflex® CF140.UL control cable PVC',
        'ja-JP': 'チェーンフレックスCF140.UL 制御ケーブル PVC外被',
    },
};
exports.mockSteuerleitung2 = {
    Aussendurchmesser: { Value: 11, Unit: 'mm' },
    GewichtKgProKm: { Value: 182, Unit: 'kg_km' },
    RAL_Nummer: '7001',
    FesteLaenge: false,
    ArtNr: { DE: 'CF140.10.07.UL', US: 'CF140-10-07-UL' },
    Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
    MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
    ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    Leitungsaufbau: { 'de-DE': '(7G1,0)C' },
    Id: 32957,
    BiegeradiusMin: { Value: 82.5, Unit: 'mm' },
    Kupferzahl: { Value: 110, Unit: 'kg_km' },
    Bezeichnung: {
        'de-DE': 'chainflex® CF140.UL Steuerleitung PVC',
        'hu-HU': 'chainflex® CF140.D PVC vezérlőkábel',
        'en-US': 'chainflex® CF140.UL control cable PVC',
        'zh-TW': 'chainflex® CF140.UL高柔性控制電纜PVC',
        'ko-KR': 'Chainflex® CF140.UL 제어 케이블 PVC',
        'es-ES': 'chainflex® CF140.UL cable de control PVC',
        'zh-CN': 'chainflex® CF140.UL高柔性控制电缆PVC',
        'it-IT': 'Cavo di comando chainflex® CF140.UL in PVC',
        'pl-PL': 'Przewód sterowania chainflex® CF140.UL PVC',
        'nl-NL': 'chainflex® CF140.UL stuurstroomkabel PVC',
        'pt-PT': 'Cabo de comando chainflex® CF140.UL em PVC',
        'sv-SE': 'chainflex® CF140.UL styrkabel PVC',
        'da-DK': 'chainflex® CF140.UL PVC-styrekabel',
        'cs-CZ': 'Ovládací kabel chainflex® CF140.UL, PVC',
        'fr-FR': 'Câble de commandes PVC chainflex® CF140.UL',
        'en-GB': 'chainflex® CF140.UL control cable PVC',
        'ja-JP': 'チェーンフレックスCF140.UL 制御ケーブル PVC外被',
    },
};
exports.mockDatenleitung = {
    Aussendurchmesser: { Value: 5, Unit: 'mm' },
    GewichtKgProKm: { Value: 28, Unit: 'kg_km' },
    RAL_Nummer: '7001',
    FesteLaenge: false,
    ArtNr: { DE: 'CF240.01.03', US: 'CF240-01-03' },
    Categories: [LeitungCategory_1.LeitungCategory.DataCables],
    MainCategory: LeitungCategory_1.LeitungCategory.DataCables,
    ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    Leitungsaufbau: { 'de-DE': '(3x0,14)C' },
    Id: 33300,
    BiegeradiusMin: { Value: 50, Unit: 'mm' },
    Kupferzahl: { Value: 15, Unit: 'kg_km' },
    Bezeichnung: {
        'de-DE': 'chainflex® CF240 Datenleitung PVC',
        'hu-HU': 'chainflex® CF240 PVC adatkábel',
        'en-US': 'chainflex® CF240 data cable PVC',
        'zh-TW': 'chainflex® CF240高柔性數據電纜PVC',
        'ko-KR': 'Chainflex® CF240 데이타 케이블 PVC',
        'es-ES': 'Conductor de datos chainflex® CF240 PVC',
        'zh-CN': 'chainflex® CF240高柔性数据电缆PVC',
        'it-IT': 'chainflex® CF240 cavo per trasmissione dati PVC',
        'pl-PL': 'chainflex® CF240 przewody do transmisji danych PVC',
        'nl-NL': 'chainflex® CF240 datakabel PVC',
        'pt-PT': 'chainflex® CF240 - Cabo de dados em PVC',
        'sv-SE': 'chainflex® CF240 PVC-datakabel',
        'da-DK': 'PVC datakabel chainflex® CF240',
        'cs-CZ': 'Datový kabel chainflex® CF240 PVC',
        'fr-FR': 'Câble de données chainflex® CF240 PVC',
        'en-GB': 'chainflex® CF240 data cable PVC',
        'ja-JP': 'チェーンフレックスCF240 シールド付きケーブル PVC外被',
    },
};
exports.mockMotorleitung = {
    Aussendurchmesser: { Value: 8, Unit: 'mm' },
    GewichtKgProKm: { Value: 121, Unit: 'kg_km' },
    RAL_Nummer: '2003',
    FesteLaenge: false,
    ArtNr: { DE: 'CF885.15.04', US: 'CF885-15-04' },
    Categories: [LeitungCategory_1.LeitungCategory.MotorCables],
    MainCategory: LeitungCategory_1.LeitungCategory.MotorCables,
    ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
    Leitungsaufbau: { 'de-DE': '4G1,5' },
    Id: 69961,
    BiegeradiusMin: { Value: 120, Unit: 'mm' },
    Kupferzahl: { Value: 64, Unit: 'kg_km' },
    Bezeichnung: {
        'de-DE': 'chainflex® CF885 Motorleitung PVC',
        'hu-HU': 'chainflex® CF885 PVC motorkábel',
        'en-US': 'chainflex® CF885 motor cable PVC',
        'zh-TW': 'chainflex® CF885 驅動電纜 PVC',
        'ko-KR': 'Chainflex® CF885 모터케이블 PVC',
        'es-ES': 'Cable de motor chainflex® CF885 PVC',
        'zh-CN': 'chainflex® CF885 驱动电缆 PVC',
        'it-IT': 'chainflex® CF885 cavo motore PVC',
        'pl-PL': 'Przewód silnikowy chainflex® CF885 z PCW',
        'nl-NL': 'chainflex® CF885 motorkabel PVC',
        'pt-PT': 'Cabo de Potência chainflex® CF885 em PVC',
        'sv-SE': 'chainflex® CF885 PVC-motorkabel',
        'da-DK': 'PVC motorkabel chainflex® CF885',
        'cs-CZ': 'Motorový kabel chainflex® CF885 z PVC',
        'fr-FR': 'Câble de puissance pour moteurs chainflex® CF885 PVC',
        'en-GB': 'chainflex® CF885 motor cable PVC',
        'ja-JP': 'チェーンフレックスCF885 モータケーブル PVC外被',
    },
};
exports.mockFreieLeitung4mm = {
    Aussendurchmesser: { Value: 4, Unit: 'mm' },
    GewichtKgProKm: { Value: 1, Unit: 'kg_km' },
    RAL_Nummer: '6005',
    ArtNrExists: false,
    Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
    MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
    BiegeradiusMin: { Value: 1, Unit: 'mm' },
    Bezeichnung: { 'de-DE': 'test' },
};
/**
 * Creates a E6.29.11 vertical IA for Kette E4.56.
 */
exports.mockFlatIa_E4_56 = {
    IAHKOLOH: { Value: 5.6, Unit: 'mm' },
    IAHKOROB: { Value: 0, Unit: 'mm' },
    IAHKBOT: { Value: 4.7, Unit: 'mm' },
    ArtyIntersect: '2600|2510',
    IAHKULOB: { Value: 1.5, Unit: 'mm' },
    IAHKULUH: { Value: 5.6, Unit: 'mm' },
    IAHKURUB: { Value: 0, Unit: 'mm' },
    Artikeltyp: 2310,
    IAHKOLUB: { Value: 1.5, Unit: 'mm' },
    IAHKULUB: { Value: 0, Unit: 'mm' },
    IAHKULOH: { Value: 1.7, Unit: 'mm' },
    IAHKUROB: { Value: 1.5, Unit: 'mm' },
    IAHKOLOB: { Value: 0, Unit: 'mm' },
    IAHKOLUH: { Value: 1.7, Unit: 'mm' },
    IAHKORUB: { Value: 1.5, Unit: 'mm' },
    IAHKULB: { Value: 1.5, Unit: 'mm' },
    IAHKURB: { Value: 1.5, Unit: 'mm' },
    IAHKOLB: { Value: 1.5, Unit: 'mm' },
    BestTyp: 300,
    IAHKRep: 7,
    IAHKDist: { Value: 7, Unit: 'mm' },
    IAHKORB: { Value: 1.5, Unit: 'mm' },
    Fussbreite: { Value: 6, Unit: 'mm' },
    IAHKH: { Value: 56, Unit: 'mm' },
    KetteSerieRef: [
        { Artikeltyp: 2310, Kuerzel: '400', Id: 14184 },
        { Artikeltyp: 2310, Kuerzel: '410', Id: 15088 },
        { Artikeltyp: 2310, Kuerzel: '880', Id: 15548 },
        { Artikeltyp: 2310, Kuerzel: '4040', Id: 15758 },
        { Artikeltyp: 2310, Kuerzel: '4140', Id: 16551 },
        { Artikeltyp: 2310, Kuerzel: '8840', Id: 17013 },
        { Artikeltyp: 2310, Kuerzel: '88', Id: 18488 },
        { Artikeltyp: 2310, Kuerzel: '14040', Id: 29208 },
        { Artikeltyp: 2310, Kuerzel: '14140', Id: 29908 },
        { Artikeltyp: 2310, Kuerzel: '18840', Id: 32388 },
        { Artikeltyp: 2310, Kuerzel: 'E4.56', Id: 40507 },
        { Artikeltyp: 2310, Kuerzel: 'H4.56', Id: 43367 },
        { Artikeltyp: 2310, Kuerzel: 'R4.56', Id: 44878 },
        { Artikeltyp: 2310, Kuerzel: '4040HD', Id: 50344 },
        { Artikeltyp: 2310, Kuerzel: '8840HD', Id: 50491 },
    ],
    ArtNr: { DE: '418', US: '418' },
    IAHKHeight: { Value: 4.5, Unit: 'mm' },
    Id: 637,
    KetteRef: [],
    Montiert: true,
    IAHKB: { Value: 3, Unit: 'mm' },
    Bezeichnung: {
        'de-DE': 'Höhenschlitzsteg, montiert',
        'hu-HU': 'Hornyolt elválasztó, szerelt',
        'en-US': 'Slotted separator, assembled ',
        'zh-TW': '帶孔橫隔片支架，裝配件',
        'ko-KR': '슬롯형 분리대, 조립',
        'es-ES': 'Separador vertical ranurado, montado',
        'zh-CN': '带孔横隔片支架，装配件',
        'it-IT': 'Separatore forato, montato',
        'pl-PL': 'Zamontowany separator szczelinowy',
        'nl-NL': 'Scheidingsschot met sleuven, gemonteerd',
        'pt-PT': 'Separador ranhurado, montado',
        'sv-SE': 'Slitsad avdelare, monterad',
        'da-DK': 'Separator med slids, samlet',
        'cs-CZ': 'Drážkovaný oddělovač, sestavený',
        'fr-FR': 'Séparateur à fente ouvert, monté',
        'en-GB': 'Slotted separator, assembled',
        'ja-JP': 'スロットセパレーター、エナジーチェーンに組付',
    },
};
/**
 * Creates a E6.29.11 vertical IA for Kette E6.29.
 */
exports.mockFlatIa_E6_29_11 = {
    IAHKOLOH: { Value: 2.3, Unit: 'mm' },
    IAHKOROB: { Value: 0, Unit: 'mm' },
    IAHKBOT: { Value: 3, Unit: 'mm' },
    IAHKULOB: { Value: 3.3, Unit: 'mm' },
    IAHKULUH: { Value: 2.3, Unit: 'mm' },
    IAHKURUB: { Value: 0, Unit: 'mm' },
    Artikeltyp: 2110,
    IAHKOLUB: { Value: 3.3, Unit: 'mm' },
    IAHKULUB: { Value: 0, Unit: 'mm' },
    IAHKULOH: { Value: 2, Unit: 'mm' },
    IAHKUROB: { Value: 3.3, Unit: 'mm' },
    IAHKOLOB: { Value: 0, Unit: 'mm' },
    IAHKOLUH: { Value: 2, Unit: 'mm' },
    IAHKORUB: { Value: 3.3, Unit: 'mm' },
    IAHKULB: { Value: 3.3, Unit: 'mm' },
    IAHKURB: { Value: 3.3, Unit: 'mm' },
    IAHKOLB: { Value: 3.3, Unit: 'mm' },
    BestTyp: 300,
    ArtNrIntersect: '111.',
    IAHKRep: 5,
    IAHKDist: { Value: 5, Unit: 'mm' },
    IAHKORB: { Value: 3.3, Unit: 'mm' },
    Fussbreite: { Value: 8, Unit: 'mm' },
    IAHKH: { Value: 28, Unit: 'mm' },
    KetteSerieRef: [
        { Artikeltyp: 2110, Kuerzel: 'E6.29', Id: 26577 },
        { Artikeltyp: 2110, Kuerzel: 'T3.29', Id: 47784 },
    ],
    ArtNr: { DE: 'E6.29.11', US: 'E6-29-11' },
    IAHKHeight: { Value: 2, Unit: 'mm' },
    Id: 26630,
    KetteRef: [],
    Montiert: true,
    IAHKB: { Value: 1.5, Unit: 'mm' },
    Bezeichnung: {
        'de-DE': 'Trennsteg geschlitzt, montiert',
        'hu-HU': 'Hornyolt elválasztók, szerelt',
        'en-US': 'Separator slotted, assembled',
        'zh-TW': '帶孔分隔片，裝配件',
        'ko-KR': '슬롯형 분리대, 조립',
        'es-ES': 'Ranura del separador, montada',
        'zh-CN': '带孔分隔片，装配件',
        'it-IT': 'Separatore forato, montato',
        'pl-PL': 'Separator, szczelinowy (zamontowany)',
        'nl-NL': 'Scheidingsschot met sleuven, gemonteerd',
        'pt-PT': 'Separador ranhurado, montado',
        'sv-SE': 'Slitsad avdelare, monterad',
        'da-DK': 'Separator med slids, samlet',
        'cs-CZ': 'Oddělovač drážkovaný, sestavený',
        'fr-FR': 'Séparateur à fente, monté',
        'en-GB': 'Slotted separator, assembled',
        'ja-JP': 'スロットセパレーター、エナジーチェーンに組付',
    },
};
/**
 * Creates a E6.29.11.R vertical IA for Kette E6.29.
 */
exports.mockFlatIa_E6_29_11_R = {
    IAHKOLOH: { Value: 2.3, Unit: 'mm' },
    IAHKOROB: { Value: 0, Unit: 'mm' },
    IAHKBOT: { Value: 3, Unit: 'mm' },
    IAHKULOB: { Value: 3.3, Unit: 'mm' },
    IAHKULUH: { Value: 2.3, Unit: 'mm' },
    IAHKURUB: { Value: 0, Unit: 'mm' },
    Artikeltyp: 2130,
    IAHKOLUB: { Value: 3.3, Unit: 'mm' },
    IAHKULUB: { Value: 0, Unit: 'mm' },
    IAHKULOH: { Value: 2, Unit: 'mm' },
    IAHKUROB: { Value: 3.3, Unit: 'mm' },
    IAHKOLOB: { Value: 0, Unit: 'mm' },
    IAHKOLUH: { Value: 2, Unit: 'mm' },
    IAHKORUB: { Value: 3.3, Unit: 'mm' },
    IAHKULB: { Value: 3.3, Unit: 'mm' },
    IAHKURB: { Value: 3.3, Unit: 'mm' },
    IAHKOLB: { Value: 3.3, Unit: 'mm' },
    BestTyp: 300,
    ArtNrIntersect: '111.',
    IAHKRep: 5,
    IAHKDist: { Value: 5, Unit: 'mm' },
    IAHKORB: { Value: 3.3, Unit: 'mm' },
    Fussbreite: { Value: 8, Unit: 'mm' },
    IAHKH: { Value: 28, Unit: 'mm' },
    KetteSerieRef: [
        { Artikeltyp: 2130, Kuerzel: 'E6.29', Id: 26577 },
        { Kuerzel: 'T3.29', Id: 47784 },
    ],
    ArtNr: { DE: 'E6.29.11.R', US: 'E6-29-11-R' },
    IAHKHeight: { Value: 2, Unit: 'mm' },
    Id: 26634,
    KetteRef: [],
    Montiert: true,
    IAHKB: { Value: 1.5, Unit: 'mm' },
    Bezeichnung: {
        'de-DE': 'Rasttrennsteg, montiert',
        'hu-HU': 'Rögzítő elválasztó, szerelt',
        'en-US': 'Detent-type separator, assembled',
        'zh-TW': '鎖緊豎隔片，裝配件',
        'ko-KR': '잠금식 분리대, 조립',
        'es-ES': 'Divisor de sujeción, montado',
        'zh-CN': '锁紧竖隔片，装配件',
        'it-IT': 'Separatore di bloccaggio, montato',
        'pl-PL': 'Zamontowany separator blokujący',
        'nl-NL': 'Borgend scheidingsschot, gemonteerd',
        'pt-PT': 'Separador rígido, montado',
        'sv-SE': 'Låsavdelare, monterad',
        'da-DK': 'Låseseparator, samlet',
        'cs-CZ': 'Zachycovací oddělovač, sestavený',
        'fr-FR': 'Séparateur enclenchable, monté',
        'en-GB': 'Notch separator, assembled',
        'ja-JP': '爪付セパレーター、エナジーチェーンに組付',
    },
};
/**
 * Creates a E6.29.12 vertical IA for Kette E6.29.
 */
exports.mockFlatIa_E6_29_12 = {
    IAHKOLOH: { Value: 2.8, Unit: 'mm' },
    IAHKOROB: { Value: 0, Unit: 'mm' },
    ArtyConnect: '2500',
    IAHKBOT: { Value: 2.7, Unit: 'mm' },
    IAHKULOB: { Value: 2, Unit: 'mm' },
    IAHKULUH: { Value: 2.8, Unit: 'mm' },
    IAHKURUB: { Value: 0, Unit: 'mm' },
    Artikeltyp: 2300,
    IAHKOLUB: { Value: 2, Unit: 'mm' },
    IAHKULUB: { Value: 0, Unit: 'mm' },
    IAHKULOH: { Value: 2, Unit: 'mm' },
    IAHKUROB: { Value: 2, Unit: 'mm' },
    IAHKOLOB: { Value: 0, Unit: 'mm' },
    IAHKOLUH: { Value: 2, Unit: 'mm' },
    IAHKORUB: { Value: 2, Unit: 'mm' },
    IAHKULB: { Value: 2, Unit: 'mm' },
    IAHKURB: { Value: 2, Unit: 'mm' },
    IAHKOLB: { Value: 2, Unit: 'mm' },
    BestTyp: 300,
    ArtNrIntersect: '221.',
    IAHKRep: 5,
    IAHKDist: { Value: 5, Unit: 'mm' },
    IAHKORB: { Value: 2, Unit: 'mm' },
    Fussbreite: { Value: 8, Unit: 'mm' },
    IAHKH: { Value: 28, Unit: 'mm' },
    KetteSerieRef: [
        { Artikeltyp: 2300, Kuerzel: 'E6.29', Id: 26577 },
        { Artikeltyp: 2300, Kuerzel: 'T3.29', Id: 47784 },
    ],
    ArtNr: { DE: 'E6.29.12', US: 'E6-29-12' },
    IAHKHeight: { Value: 2.5, Unit: 'mm' },
    Id: 26632,
    KetteRef: [],
    Montiert: true,
    IAHKB: { Value: 4, Unit: 'mm' },
    Bezeichnung: {
        'de-DE': 'Teilungssteg, montiert',
        'hu-HU': 'Függőleges elválasztó, szerelt',
        'en-US': 'Vertical separator, assembled',
        'zh-TW': '豎隔片，裝配件',
        'ko-KR': '수직 분리대, 조립',
        'es-ES': 'Divisor, montado',
        'zh-CN': '竖隔片，装配件',
        'it-IT': 'Separatore verticale, montato',
        'pl-PL': 'Zamontowany separator pionowy',
        'nl-NL': 'Verticale afscheiding, gemonteerd',
        'pt-PT': 'Separador vertical, montado',
        'sv-SE': 'Vertikal avdelare, monterad',
        'da-DK': 'Lodret separator, samlet',
        'cs-CZ': 'Vertikální oddělovač, sestavený',
        'fr-FR': 'Séparateur, monté',
        'en-GB': 'Middle plate, assembled',
        'ja-JP': 'ディバイダー、エナジーチェーンに組付',
    },
};
/**
 * Creates a 29.1.1 vertical IA for Kette E6.29.
 */
exports.mockRoundIa_E6_29__29_1_1 = {
    IAHKOLOH: { Value: 2.1, Unit: 'mm' },
    IAHKOROB: { Value: 0, Unit: 'mm' },
    ArtyConnect: '2510',
    IAHKBOT: { Value: 5.58, Unit: 'mm' },
    ArtyIntersect: '2510',
    ArtNrConnect: '2310.',
    IAHKULOB: { Value: 2.75, Unit: 'mm' },
    IAHKULUH: { Value: 2.1, Unit: 'mm' },
    IAHKURUB: { Value: 0, Unit: 'mm' },
    Artikeltyp: 2350,
    IAHKOLUB: { Value: 2.75, Unit: 'mm' },
    IAHKULUB: { Value: 0, Unit: 'mm' },
    IAHKULOH: { Value: 0.8, Unit: 'mm' },
    IAHKUROB: { Value: 2.75, Unit: 'mm' },
    IAHKOLOB: { Value: 0, Unit: 'mm' },
    IAHKOLUH: { Value: 0.8, Unit: 'mm' },
    IAHKORUB: { Value: 2.75, Unit: 'mm' },
    IAHKULB: { Value: 2.75, Unit: 'mm' },
    IAHKURB: { Value: 2.75, Unit: 'mm' },
    IAHKOLB: { Value: 2.75, Unit: 'mm' },
    BestTyp: 300,
    IAHKOLUH_Rounded: true,
    IAHKRep: 3,
    IAHKDist: { Value: 7.5, Unit: 'mm' },
    IAHKORB: { Value: 2.75, Unit: 'mm' },
    Fussbreite: { Value: 8, Unit: 'mm' },
    IAHKH: { Value: 29, Unit: 'mm' },
    KetteSerieRef: [
        { Artikeltyp: 2110, Kuerzel: 'E6.29', Id: 26577 },
        { Artikeltyp: 2110, Kuerzel: 'T3.29', Id: 47784 },
        { Artikeltyp: 2110, Kuerzel: 'E61.29', Id: 59091 },
        { Artikeltyp: 2110, Kuerzel: 'EF61.29', Id: 78921 },
    ],
    ArtNr: { DE: '29.1.1', US: '29-1-1' },
    IAHKHeight: { Value: 2.3, Unit: 'mm' },
    IAHKULOH_Rounded: true,
    Id: 66456,
    KetteRef: [],
    Montiert: true,
    IAHKB: { Value: 2.5, Unit: 'mm' },
    Bezeichnung: {
        'de-DE': 'Trennsteg geschlitzt, montiert',
        'hu-HU': 'Hornyolt elválasztók, szerelt',
        'en-US': 'Separator slotted, assembled',
        'ko-KR': '슬롯형 분리대, 조립',
        'es-ES': 'Ranura del separador, montada',
        'zh-CN': '带孔分隔片，装配件',
        'nl-NL': 'Scheidingsschot met sleuven, gemonteerd',
        'sv-SE': 'Slitsad avdelare, monterad',
        'da-DK': 'Separator med slids, samlet',
        'cs-CZ': 'Oddělovač drážkovaný, sestavený',
        'fr-FR': 'Séparateur à fente, monté',
        'en-GB': 'Slotted separator, assembled',
        'ja-JP': 'スロットセパレーター、エナジーチェーンに組付',
    },
};
/**
 * Creates a E6.29.13 Seitenplatte for Kette E6.29.
 */
exports.mockSeitenplatteIa_E6_29_13 = {
    IAHKOLOH: { Value: 3, Unit: 'mm' },
    IAHKOROB: { Value: 0, Unit: 'mm' },
    IAHKBOT: { Value: 2.7, Unit: 'mm' },
    ArtNrConnect: '2210.|221.',
    IAHKULOB: { Value: 0, Unit: 'mm' },
    IAHKULUH: { Value: 3, Unit: 'mm' },
    IAHKURUB: { Value: 0, Unit: 'mm' },
    Artikeltyp: 2200,
    IAHKOLUB: { Value: 0, Unit: 'mm' },
    IAHKULUB: { Value: 0, Unit: 'mm' },
    IAHKULOH: { Value: 1.5, Unit: 'mm' },
    IAHKUROB: { Value: 4, Unit: 'mm' },
    IAHKOLOB: { Value: 0, Unit: 'mm' },
    IAHKOLUH: { Value: 1.5, Unit: 'mm' },
    IAHKORUB: { Value: 4, Unit: 'mm' },
    IAHKULB: { Value: 0, Unit: 'mm' },
    IAHKURB: { Value: 4, Unit: 'mm' },
    IAHKOLB: { Value: 0, Unit: 'mm' },
    BestTyp: 300,
    IAHKRep: 5,
    IAHKDist: { Value: 5, Unit: 'mm' },
    IAHKORB: { Value: 4, Unit: 'mm' },
    Fussbreite: { Value: 7, Unit: 'mm' },
    IAHKH: { Value: 28, Unit: 'mm' },
    KetteSerieRef: [
        { Artikeltyp: 2200, Kuerzel: 'E6.29', Id: 26577 },
        { Artikeltyp: 2200, Kuerzel: 'T3.29', Id: 47784 },
    ],
    ArtNr: { DE: 'E6.29.13', US: 'E6-29-13' },
    IAHKHeight: { Value: 2.5, Unit: 'mm' },
    Id: 26636,
    KetteRef: [],
    Montiert: true,
    IAHKB: { Value: 4, Unit: 'mm' },
    Bezeichnung: {
        'de-DE': 'Seitenplatte, montiert',
        'hu-HU': 'Oldallap, szerelt',
        'en-US': 'Side plate, assembled',
        'zh-TW': '側邊橫隔片支架，裝配件',
        'ko-KR': '사이드 플레이트, 조립',
        'es-ES': 'Placa lateral, montada',
        'zh-CN': '侧边横隔片支架，装配件',
        'it-IT': 'Piastra laterale, montata',
        'pl-PL': 'Płytka boczna, niezamontowana',
        'nl-NL': 'Zijplaat, gemonteerd',
        'pt-PT': 'Prato lateral montado',
        'sv-SE': 'Sidoplatta, monterad',
        'da-DK': 'Sideplade, samlet',
        'cs-CZ': 'Bočnice, sestavená',
        'fr-FR': 'Plaque latérale, montée',
        'en-GB': 'Side plate, assembled',
        'ja-JP': 'サイドプレート、エナジーチェーンに組付',
    },
};
/**
 * Creates a 111.60 horizontal IA for Kette E6.29.
 */
exports.mockSmallEinsteckbodenIa_E6_29 = {
    Artikeltyp: 2400,
    KetteSerieRef: [
        { Artikeltyp: 2400, Kuerzel: '210', Id: 6029 },
        { Artikeltyp: 2400, Kuerzel: 'E6.29', Id: 26577 },
        { Artikeltyp: 2400, Kuerzel: 'E4.21', Id: 38985 },
        { Artikeltyp: 2400, Kuerzel: 'E6.35', Id: 46487 },
        { Artikeltyp: 2400, Kuerzel: 'T3.29', Id: 47784 },
        { Artikeltyp: 2400, Kuerzel: 'R6.40', Id: 47942 },
        { Artikeltyp: 2400, Kuerzel: 'E61.35', Id: 76142 },
    ],
    BestTyp: 300,
    IAwmm: { Value: 60, Unit: 'mm' },
    ArtNr: { DE: '111.60', US: '111-60' },
    IAUebermass: { Value: 0, Unit: 'mm' },
    Breite: { Value: 60, Unit: 'mm' },
    IABodenH: { Value: 2, Unit: 'mm' },
    Id: 6116,
    KetteRef: [
        6052, 6053, 6054, 6055, 6056, 6057, 6058, 26591, 26592, 26593, 26594, 39025, 39026, 39027, 39028, 39029, 39030,
        39031, 46305, 46315, 47817, 47921, 47923,
    ],
    Montiert: true,
    Bezeichnung: {
        'de-DE': 'Einsteckboden, montiert',
        'hu-HU': 'Betett polc, szerelt',
        'en-US': 'Full shelf, assembled',
        'zh-TW': '全寬水準分隔片，裝配件',
        'ko-KR': '전폭 가로분리대, 조립',
        'es-ES': 'Base insertable, montada',
        'zh-CN': '全宽水平分隔片，装配件',
        'it-IT': 'Separatore orizzontale a piena larghezza, montato',
        'pl-PL': 'Półka o pełnej szerokości, zmontowana',
        'nl-NL': 'Tussenschot met maximale breedte, gemonteerd',
        'pt-PT': 'Travessa longitudinal, montada',
        'sv-SE': 'Hyllplan, monterat',
        'da-DK': 'Hylde i fuld bredde, samlet',
        'cs-CZ': 'Příčka v plné šíři, sestavená',
        'fr-FR': 'Fond amovible, monté',
        'en-GB': 'Full-width shelf, assembled',
        'ja-JP': '貫通型棚板、エナジーチェーンに組付け',
    },
};
/**
 * Creates a 111.100 horizontal IA for Kette E6.29.
 */
exports.mockEinsteckbodenIa_E6_29 = {
    Artikeltyp: 2400,
    KetteSerieRef: [
        { Artikeltyp: 2400, Kuerzel: '15', Id: 1451 },
        { Artikeltyp: 2400, Kuerzel: '17', Id: 1600 },
        { Artikeltyp: 2400, Kuerzel: 'R15', Id: 1707 },
        { Artikeltyp: 2400, Kuerzel: 'R17', Id: 1790 },
        { Artikeltyp: 2400, Kuerzel: 'B15', Id: 2183 },
        { Artikeltyp: 2400, Kuerzel: 'B15i', Id: 2264 },
        { Artikeltyp: 2400, Kuerzel: 'B17', Id: 2345 },
        { Artikeltyp: 2400, Kuerzel: '1400', Id: 3831 },
        { Artikeltyp: 2400, Kuerzel: '1450', Id: 3936 },
        { Artikeltyp: 2400, Kuerzel: '1500', Id: 3989 },
        { Artikeltyp: 2400, Kuerzel: '210', Id: 6029 },
        { Artikeltyp: 2400, Kuerzel: 'E6.29', Id: 26577 },
        { Artikeltyp: 2400, Kuerzel: '1480', Id: 31081 },
        { Artikeltyp: 2400, Kuerzel: 'E4.21', Id: 38985 },
        { Artikeltyp: 2400, Kuerzel: 'B17i', Id: 46356 },
        { Artikeltyp: 2400, Kuerzel: 'E6.35', Id: 46487 },
        { Artikeltyp: 2400, Kuerzel: 'T3.29', Id: 47784 },
        { Artikeltyp: 2400, Kuerzel: 'R6.40', Id: 47942 },
        { Artikeltyp: 2400, Kuerzel: 'E61.35', Id: 76142 },
    ],
    BestTyp: 300,
    IAwmm: { Value: 100, Unit: 'mm' },
    ArtNr: { DE: '111.100', US: '111-100' },
    IAUebermass: { Value: 0, Unit: 'mm' },
    Breite: { Value: 100, Unit: 'mm' },
    IABodenH: { Value: 2, Unit: 'mm' },
    Id: 1554,
    KetteRef: [
        1501, 1502, 1503, 1504, 1505, 1506, 1507, 1508, 1626, 1627, 1628, 1629, 2233, 2234, 2235, 2236, 2237, 2238, 2239,
        2240, 2314, 2315, 2316, 2317, 2318, 2319, 2320, 2321, 2375, 2376, 2377, 2378, 3881, 3882, 3883, 3884, 3885, 3886,
        3887, 3888, 3968, 3969, 3970, 3971, 3972, 4039, 4040, 4041, 4042, 4043, 4044, 4045, 4046, 6080, 6081, 6082, 6083,
        6084, 6085, 6086, 26607, 26608, 26609, 26610, 39053, 39054, 39055, 39056, 39057, 39058, 39059, 46299, 46300, 46301,
        46302, 46309, 46319, 47821, 47933, 47935, 48355, 48356, 48357, 48358, 48359, 48457, 67959, 67984, 67992, 68000,
        68008, 68016, 68024,
    ],
    Montiert: true,
    Bezeichnung: {
        'de-DE': 'Einsteckboden, montiert',
        'hu-HU': 'Betett polc, szerelt',
        'en-US': 'Full shelf, assembled',
        'zh-TW': '全寬水準分隔片，裝配件',
        'ko-KR': '전폭 가로분리대, 조립',
        'es-ES': 'Base insertable, montada',
        'zh-CN': '全宽水平分隔片，装配件',
        'it-IT': 'Separatore orizzontale a piena larghezza, montato',
        'pl-PL': 'Półka o pełnej szerokości, zmontowana',
        'nl-NL': 'Tussenschot met maximale breedte, gemonteerd',
        'pt-PT': 'Travessa longitudinal, montada',
        'sv-SE': 'Hyllplan, monterat',
        'da-DK': 'Hylde i fuld bredde, samlet',
        'cs-CZ': 'Příčka v plné šíři, sestavená',
        'fr-FR': 'Fond amovible, monté',
        'en-GB': 'Full-width shelf, assembled',
        'ja-JP': '貫通型棚板、エナジーチェーンに組付け',
    },
};
/**
 * Creates a 2210.18 horizontal IA for Kette E6.29.
 */
exports.mockFachbodenIa_E6_29__2210_18 = {
    Artikeltyp: 2500,
    KetteSerieRef: [
        { Artikeltyp: 2500, Kuerzel: '240', Id: 2605 },
        { Artikeltyp: 2500, Kuerzel: '250', Id: 2771 },
        { Artikeltyp: 2500, Kuerzel: '255', Id: 2883 },
        { Artikeltyp: 2500, Kuerzel: '27', Id: 3170 },
        { Artikeltyp: 2500, Kuerzel: '27i', Id: 3297 },
        { Artikeltyp: 2500, Kuerzel: '340', Id: 3402 },
        { Artikeltyp: 2500, Kuerzel: '350', Id: 3712 },
        { Artikeltyp: 2500, Kuerzel: '2400', Id: 4073 },
        { Artikeltyp: 2500, Kuerzel: '2500', Id: 4324 },
        { Artikeltyp: 2500, Kuerzel: '2600', Id: 4436 },
        { Artikeltyp: 2500, Kuerzel: '2650', Id: 4583 },
        { Artikeltyp: 2500, Kuerzel: '2700', Id: 4664 },
        { Artikeltyp: 2500, Kuerzel: '3400', Id: 4777 },
        { Artikeltyp: 2500, Kuerzel: '3450', Id: 4891 },
        { Artikeltyp: 2500, Kuerzel: '3500', Id: 4980 },
        { Artikeltyp: 2500, Kuerzel: '157', Id: 5230 },
        { Artikeltyp: 2500, Kuerzel: '158', Id: 5351 },
        { Artikeltyp: 2500, Kuerzel: '167', Id: 5428 },
        { Artikeltyp: 2500, Kuerzel: '168', Id: 5563 },
        { Artikeltyp: 2500, Kuerzel: '58', Id: 5741 },
        { Artikeltyp: 2500, Kuerzel: '68', Id: 5875 },
        { Artikeltyp: 2500, Kuerzel: '760', Id: 6409 },
        { Artikeltyp: 2500, Kuerzel: '76', Id: 6971 },
        { Artikeltyp: 2500, Kuerzel: 'E6.29', Id: 26577 },
        { Artikeltyp: 2500, Kuerzel: 'E6.52', Id: 26666 },
        { Artikeltyp: 2500, Kuerzel: 'E6.40', Id: 32125 },
        { Artikeltyp: 2500, Kuerzel: '2680', Id: 36705 },
        { Artikeltyp: 2500, Kuerzel: '3480', Id: 38489 },
        { Artikeltyp: 2500, Kuerzel: 'E4.28', Id: 39110 },
        { Artikeltyp: 2500, Kuerzel: 'R4.28', Id: 44327 },
        { Artikeltyp: 2500, Kuerzel: 'E6.35', Id: 46487 },
        { Artikeltyp: 2500, Kuerzel: 'T3.29', Id: 47784 },
        { Artikeltyp: 2500, Kuerzel: 'E61.35', Id: 76142 },
        { Artikeltyp: 2500, Kuerzel: 'E61.40', Id: 76215 },
    ],
    BestTyp: 300,
    IAwmm: { Value: 19.2, Unit: 'mm' },
    ArtNr: { DE: '2210.18', US: '2210-18' },
    IAUebermass: { Value: 7, Unit: 'mm' },
    Breite: { Value: 19.2, Unit: 'mm' },
    IABodenH: { Value: 2.5, Unit: 'mm' },
    Id: 2695,
    KetteRef: [],
    Montiert: true,
    Bezeichnung: {
        'de-DE': 'Fachboden, montiert',
        'hu-HU': 'Polc, szerelt',
        'en-US': 'Shelf, assembled ',
        'zh-TW': '支架，裝配件',
        'ko-KR': '가로분리대, 조립',
        'es-ES': 'Bandeja intermedia, montada',
        'zh-CN': '支架，装配件',
        'it-IT': 'Separatore orizzontale, montato',
        'pl-PL': 'Zamontowana półka',
        'nl-NL': 'Tussenschot, gemonteerd',
        'pt-PT': 'Travessa, montada',
        'sv-SE': 'Hyllfack, monterat',
        'da-DK': 'Hylde, samlet',
        'cs-CZ': 'Příčka, sestavená',
        'fr-FR': 'Fond intercalaire, monté',
        'en-GB': 'Shelf, assembled',
        'ja-JP': '棚板、エナジーチェーンに組付',
    },
};
/**
 * Creates a 2210.23 horizontal IA for Kette E6.29.
 */
exports.mockFachbodenIa_E6_29__2210_23 = {
    Artikeltyp: 2500,
    KetteSerieRef: [
        { Artikeltyp: 2500, Kuerzel: '240', Id: 2605 },
        { Artikeltyp: 2500, Kuerzel: '250', Id: 2771 },
        { Artikeltyp: 2500, Kuerzel: '255', Id: 2883 },
        { Artikeltyp: 2500, Kuerzel: '27', Id: 3170 },
        { Artikeltyp: 2500, Kuerzel: '27i', Id: 3297 },
        { Artikeltyp: 2500, Kuerzel: '340', Id: 3402 },
        { Artikeltyp: 2500, Kuerzel: '350', Id: 3712 },
        { Artikeltyp: 2500, Kuerzel: '2400', Id: 4073 },
        { Artikeltyp: 2500, Kuerzel: '2500', Id: 4324 },
        { Artikeltyp: 2500, Kuerzel: '2600', Id: 4436 },
        { Artikeltyp: 2500, Kuerzel: '2650', Id: 4583 },
        { Artikeltyp: 2500, Kuerzel: '2700', Id: 4664 },
        { Artikeltyp: 2500, Kuerzel: '3400', Id: 4777 },
        { Artikeltyp: 2500, Kuerzel: '3450', Id: 4891 },
        { Artikeltyp: 2500, Kuerzel: '3500', Id: 4980 },
        { Artikeltyp: 2500, Kuerzel: '157', Id: 5230 },
        { Artikeltyp: 2500, Kuerzel: '158', Id: 5351 },
        { Artikeltyp: 2500, Kuerzel: '167', Id: 5428 },
        { Artikeltyp: 2500, Kuerzel: '168', Id: 5563 },
        { Artikeltyp: 2500, Kuerzel: '58', Id: 5741 },
        { Artikeltyp: 2500, Kuerzel: '68', Id: 5875 },
        { Artikeltyp: 2500, Kuerzel: '760', Id: 6409 },
        { Artikeltyp: 2500, Kuerzel: '76', Id: 6971 },
        { Artikeltyp: 2500, Kuerzel: 'E6.29', Id: 26577 },
        { Artikeltyp: 2500, Kuerzel: 'E6.52', Id: 26666 },
        { Artikeltyp: 2500, Kuerzel: 'E6.40', Id: 32125 },
        { Artikeltyp: 2500, Kuerzel: '2680', Id: 36705 },
        { Artikeltyp: 2500, Kuerzel: '3480', Id: 38489 },
        { Artikeltyp: 2500, Kuerzel: 'E4.28', Id: 39110 },
        { Artikeltyp: 2500, Kuerzel: 'R4.28', Id: 44327 },
        { Artikeltyp: 2500, Kuerzel: 'E6.35', Id: 46487 },
        { Artikeltyp: 2500, Kuerzel: 'T3.29', Id: 47784 },
        { Artikeltyp: 2500, Kuerzel: 'E61.35', Id: 76142 },
        { Artikeltyp: 2500, Kuerzel: 'E61.40', Id: 76215 },
    ],
    BestTyp: 300,
    IAwmm: { Value: 24.2, Unit: 'mm' },
    ArtNr: { DE: '2210.23', US: '2210-23' },
    IAUebermass: { Value: 7, Unit: 'mm' },
    Breite: { Value: 24.2, Unit: 'mm' },
    IABodenH: { Value: 2.5, Unit: 'mm' },
    Id: 2696,
    KetteRef: [],
    Montiert: true,
    Bezeichnung: {
        'de-DE': 'Fachboden, montiert',
        'hu-HU': 'Polc, szerelt',
        'en-US': 'Shelf, assembled ',
        'zh-TW': '支架，裝配件',
        'ko-KR': '가로분리대, 조립',
        'es-ES': 'Bandeja intermedia, montada',
        'zh-CN': '支架，装配件',
        'it-IT': 'Separatore orizzontale, montato',
        'pl-PL': 'Zamontowana półka',
        'nl-NL': 'Tussenschot, gemonteerd',
        'pt-PT': 'Travessa, montada',
        'sv-SE': 'Hyllfack, monterat',
        'da-DK': 'Hylde, samlet',
        'cs-CZ': 'Příčka, sestavená',
        'fr-FR': 'Fond intercalaire, monté',
        'en-GB': 'Shelf, assembled',
        'ja-JP': '棚板、エナジーチェーンに組付',
    },
};
/**
 * Creates a 2210.33 horizontal IA for Kette E6.29.
 */
exports.mockFachbodenIa_E6_29__2210_33 = {
    Artikeltyp: 2500,
    KetteSerieRef: [
        { Artikeltyp: 2500, Kuerzel: '240', Id: 2605 },
        { Artikeltyp: 2500, Kuerzel: '250', Id: 2771 },
        { Artikeltyp: 2500, Kuerzel: '255', Id: 2883 },
        { Artikeltyp: 2500, Kuerzel: '27', Id: 3170 },
        { Artikeltyp: 2500, Kuerzel: '27i', Id: 3297 },
        { Artikeltyp: 2500, Kuerzel: '340', Id: 3402 },
        { Artikeltyp: 2500, Kuerzel: '350', Id: 3712 },
        { Artikeltyp: 2500, Kuerzel: '2400', Id: 4073 },
        { Artikeltyp: 2500, Kuerzel: '2500', Id: 4324 },
        { Artikeltyp: 2500, Kuerzel: '2600', Id: 4436 },
        { Artikeltyp: 2500, Kuerzel: '2650', Id: 4583 },
        { Artikeltyp: 2500, Kuerzel: '2700', Id: 4664 },
        { Artikeltyp: 2500, Kuerzel: '3400', Id: 4777 },
        { Artikeltyp: 2500, Kuerzel: '3450', Id: 4891 },
        { Artikeltyp: 2500, Kuerzel: '3500', Id: 4980 },
        { Artikeltyp: 2500, Kuerzel: '157', Id: 5230 },
        { Artikeltyp: 2500, Kuerzel: '158', Id: 5351 },
        { Artikeltyp: 2500, Kuerzel: '167', Id: 5428 },
        { Artikeltyp: 2500, Kuerzel: '168', Id: 5563 },
        { Artikeltyp: 2500, Kuerzel: '58', Id: 5741 },
        { Artikeltyp: 2500, Kuerzel: '68', Id: 5875 },
        { Artikeltyp: 2500, Kuerzel: '760', Id: 6409 },
        { Artikeltyp: 2500, Kuerzel: '76', Id: 6971 },
        { Artikeltyp: 2500, Kuerzel: 'E6.29', Id: 26577 },
        { Artikeltyp: 2500, Kuerzel: 'E6.52', Id: 26666 },
        { Artikeltyp: 2500, Kuerzel: 'E6.40', Id: 32125 },
        { Artikeltyp: 2500, Kuerzel: '2680', Id: 36705 },
        { Artikeltyp: 2500, Kuerzel: '3480', Id: 38489 },
        { Artikeltyp: 2500, Kuerzel: 'E4.28', Id: 39110 },
        { Artikeltyp: 2500, Kuerzel: 'R4.28', Id: 44327 },
        { Artikeltyp: 2500, Kuerzel: 'E6.35', Id: 46487 },
        { Artikeltyp: 2500, Kuerzel: 'T3.29', Id: 47784 },
        { Artikeltyp: 2500, Kuerzel: 'E61.35', Id: 76142 },
        { Artikeltyp: 2500, Kuerzel: 'E61.40', Id: 76215 },
    ],
    BestTyp: 300,
    IAwmm: { Value: 34.2, Unit: 'mm' },
    ArtNr: { DE: '2210.33', US: '2210-33' },
    IAUebermass: { Value: 7, Unit: 'mm' },
    Breite: { Value: 34.2, Unit: 'mm' },
    IABodenH: { Value: 2.5, Unit: 'mm' },
    Id: 2698,
    KetteRef: [],
    Montiert: true,
    Bezeichnung: {
        'de-DE': 'Fachboden, montiert',
        'hu-HU': 'Polc, szerelt',
        'en-US': 'Shelf, assembled ',
        'zh-TW': '支架，裝配件',
        'ko-KR': '가로분리대, 조립',
        'es-ES': 'Bandeja intermedia, montada',
        'zh-CN': '支架，装配件',
        'it-IT': 'Separatore orizzontale, montato',
        'pl-PL': 'Zamontowana półka',
        'nl-NL': 'Tussenschot, gemonteerd',
        'pt-PT': 'Travessa, montada',
        'sv-SE': 'Hyllfack, monterat',
        'da-DK': 'Hylde, samlet',
        'cs-CZ': 'Příčka, sestavená',
        'fr-FR': 'Fond intercalaire, monté',
        'en-GB': 'Shelf, assembled',
        'ja-JP': '棚板、エナジーチェーンに組付',
    },
};
/**
 * Creates a 2310.025 horizontal IA for Kette E6.29.
 */
exports.mockUniversalbodenIa_E6_29__2310_025 = {
    Artikeltyp: 2510,
    KetteSerieRef: [
        { Artikeltyp: 2600, Kuerzel: '1400', Id: 3831 },
        { Artikeltyp: 2600, Kuerzel: '1500', Id: 3989 },
        { Artikeltyp: 2600, Kuerzel: '2400', Id: 4073 },
        { Artikeltyp: 2600, Kuerzel: '2500', Id: 4324 },
        { Artikeltyp: 2600, Kuerzel: 'E6.29', Id: 26577 },
        { Artikeltyp: 2600, Kuerzel: 'E6.52', Id: 26666 },
        { Artikeltyp: 2600, Kuerzel: 'E6.40', Id: 32125 },
        { Artikeltyp: 2600, Kuerzel: 'E4.28', Id: 39110 },
        { Artikeltyp: 2600, Kuerzel: 'E6.35', Id: 46487 },
        { Artikeltyp: 2600, Kuerzel: 'T3.29', Id: 47784 },
        { Artikeltyp: 2600, Kuerzel: 'E61.29', Id: 59091 },
        { Artikeltyp: 2600, Kuerzel: 'E61.52', Id: 67712 },
        { Artikeltyp: 2600, Kuerzel: 'E4.31L', Id: 70448 },
        { Artikeltyp: 2600, Kuerzel: 'E61.35', Id: 76142 },
        { Artikeltyp: 2600, Kuerzel: 'E61.40', Id: 76215 },
        { Artikeltyp: 2600, Kuerzel: 'R2i.26', Id: 78580 },
        { Artikeltyp: 2600, Kuerzel: 'R2.26', Id: 78849 },
        { Artikeltyp: 2600, Kuerzel: 'EF61.29', Id: 78921 },
    ],
    BestTyp: 300,
    IAwmm: { Value: 25, Unit: 'mm' },
    ArtNr: { DE: '2310.025' },
    IAUebermass: { Value: 6, Unit: 'mm' },
    Breite: { Value: 25, Unit: 'mm' },
    IABodenH: { Value: 2, Unit: 'mm' },
    Id: 54255,
    KetteRef: [],
    Montiert: true,
    Bezeichnung: {
        'de-DE': 'Einsteckboden rastbar, montiert',
        'hu-HU': 'Rögzíthető, betolható rekeszelő elem, szerelt',
        'en-US': 'Lockable push-in shelf, assembled',
        'zh-TW': '可鎖緊的推入式支架，裝配件',
        'ko-KR': '잠금식 푸시형 가로분리대, 조립',
        'es-ES': 'Fijación de la bandeja , montado.',
        'zh-CN': '可锁紧的推入式支架，装配件',
        'it-IT': 'Ripiano ad incastro assemblato',
        'pl-PL': 'Zatrzaskowa półka, zamontowana',
        'nl-NL': 'Borgbaar push-in tussenschot, gemonteerd',
        'pt-PT': 'Prateleira rígida com encaixe, montada',
        'sv-SE': 'Snap-in hyllplan, monterat',
        'da-DK': 'Låsbar skub-ind hylde, samlet',
        'cs-CZ': 'Uzamkytalená zasunovací příčka, sestavená',
        'fr-FR': 'Fond intermédiaire bloquant, monté',
        'en-GB': 'Lockable full-width shelf, assembled',
        'ja-JP': '貫通型棚板 ホールド可、 取付済',
    },
};
/**
 * Creates a 2310.050 horizontal IA for Kette E6.29.
 */
exports.mockUniversalbodenIa_E6_29__2310_050 = {
    Artikeltyp: 2510,
    KetteSerieRef: [
        { Artikeltyp: 2600, Kuerzel: '1400', Id: 3831 },
        { Artikeltyp: 2600, Kuerzel: '1500', Id: 3989 },
        { Artikeltyp: 2600, Kuerzel: '2400', Id: 4073 },
        { Artikeltyp: 2600, Kuerzel: '2500', Id: 4324 },
        { Artikeltyp: 2600, Kuerzel: 'E6.29', Id: 26577 },
        { Artikeltyp: 2600, Kuerzel: 'E6.52', Id: 26666 },
        { Artikeltyp: 2600, Kuerzel: 'E6.40', Id: 32125 },
        { Artikeltyp: 2600, Kuerzel: 'E4.28', Id: 39110 },
        { Artikeltyp: 2600, Kuerzel: 'E6.35', Id: 46487 },
        { Artikeltyp: 2600, Kuerzel: 'T3.29', Id: 47784 },
        { Artikeltyp: 2600, Kuerzel: 'E61.29', Id: 59091 },
        { Artikeltyp: 2600, Kuerzel: 'E61.52', Id: 67712 },
        { Artikeltyp: 2600, Kuerzel: 'E4.31L', Id: 70448 },
        { Artikeltyp: 2600, Kuerzel: 'E61.35', Id: 76142 },
        { Artikeltyp: 2600, Kuerzel: 'E61.40', Id: 76215 },
        { Artikeltyp: 2600, Kuerzel: 'R2i.26', Id: 78580 },
        { Artikeltyp: 2600, Kuerzel: 'R2.26', Id: 78849 },
        { Artikeltyp: 2600, Kuerzel: 'EF61.29', Id: 78921 },
    ],
    BestTyp: 300,
    IAwmm: { Value: 50, Unit: 'mm' },
    ArtNr: { DE: '2310.050' },
    IAUebermass: { Value: 6, Unit: 'mm' },
    Breite: { Value: 50, Unit: 'mm' },
    IABodenH: { Value: 2, Unit: 'mm' },
    Id: 54424,
    KetteRef: [],
    Montiert: true,
    Bezeichnung: {
        'de-DE': 'Einsteckboden rastbar, montiert',
        'hu-HU': 'Rögzíthető, betolható rekeszelő elem, szerelt',
        'en-US': 'Lockable push-in shelf, assembled',
        'zh-TW': '可鎖緊的推入式支架，裝配件',
        'ko-KR': '잠금식 푸시형 가로분리대, 조립',
        'es-ES': 'Fijación de la bandeja , montado.',
        'zh-CN': '可锁紧的推入式支架，装配件',
        'it-IT': 'Ripiano ad incastro assemblato',
        'pl-PL': 'Zatrzaskowa półka, zamontowana',
        'nl-NL': 'Borgbaar push-in tussenschot, gemonteerd',
        'pt-PT': 'Prateleira rígida com encaixe, montada',
        'sv-SE': 'Snap-in hyllplan, monterat',
        'da-DK': 'Låsbar skub-ind hylde, samlet',
        'cs-CZ': 'Uzamkytalená zasunovací příčka, sestavená',
        'fr-FR': 'Fond intermédiaire bloquant, monté',
        'en-GB': 'Lockable full-width shelf, assembled',
        'ja-JP': '貫通型棚板 ホールド可、 取付済',
    },
};
/**
 * Creates a B17 Kette domain object.
 */
exports.mockKette_B17_2_063 = {
    SerieRef: { Kuerzel: 'B17', Id: 2345 },
    FreitragenderBetriebErlaubt: true,
    GewichtKgProM: { Value: 0.59, Unit: 'kg_m' },
    Aussenbreite: { Value: 35.5, Unit: 'mm' },
    Teilung: { Value: 30.5, Unit: 'mm' },
    Halbstegig: false,
    ArtSerieBreite: 'B17.2',
    IndexBreite: '2',
    LeitungDiameterMax: { Value: 28, Unit: 'mm' },
    StandardTrennstegArtNr: '172B',
    NoSeparaterFootBottom: true,
    Innenbreite: { Value: 25, Unit: 'mm' },
    IndexBiegeradius: '063',
    K: { Value: 260, Unit: 'mm' },
    Aussenhoehe: { Value: 39, Unit: 'mm' },
    Biegeradius: { Value: 63, Unit: 'mm' },
    ArtNr: { DE: 'B17.2.063.0', US: 'B17-2-063-0' },
    UngeradeAnzahlGlieder: false,
    GleitenderBetriebErlaubt: false,
    Id: 2352,
    Innenhoehe: { Value: 32, Unit: 'mm' },
    VersatzFestpunktErlaubt: true,
    Bezeichnung: {
        'hu-HU': 'e-chain® Széria B17',
        'de-DE': 'e-kette® Serie B17',
        'en-US': 'Energy chain® Series B17',
        'zh-TW': 'B17系列拖鏈',
        'ko-KR': 'E-Chain® B17 시리즈',
        'es-ES': 'E-Chain® series B17',
        'zh-CN': 'B17系列拖链',
        'it-IT': 'Catena serie B17',
        'pl-PL': 'E-Chain® seria B17',
        'nl-NL': 'Kabelrups series B17',
        'pt-PT': 'Calhas articuladas da Série B17',
        'sv-SE': 'E-kedja serie B17',
        'da-DK': 'E-Kæde Serie B17',
        'fr-FR': 'Chaîne Porte-Câbles Série B17',
        'cs-CZ': 'e-chain® série B17',
        'ja-JP': 'エナジーチェーン B17型',
        'en-GB': 'e-chain® Series B17',
    },
};
exports.mockKette_400_20_135_0 = {
    SerieRef: { Kuerzel: '400', Id: 14184 },
    FreitragenderBetriebErlaubt: true,
    K2: { Value: 650, Unit: 'mm' },
    MinDistO: { Value: 16, Unit: 'mm' },
    MinDistU: { Value: 16, Unit: 'mm' },
    GewichtKgProM: { Value: 4.46, Unit: 'kg_m' },
    MinDistKlemmO: { Value: 44, Unit: 'mm' },
    Aussenbreite: { Value: 234, Unit: 'mm' },
    Teilung: { Value: 91, Unit: 'mm' },
    MinDistKlemmU: { Value: 44, Unit: 'mm' },
    ArtSerieBreite: '400.20',
    IndexBreite: '20',
    LeitungDiameterMax: { Value: 50, Unit: 'mm' },
    StandardTrennstegArtNr: '56.1.1',
    Innenbreite: { Value: 200, Unit: 'mm' },
    IndexBiegeradius: '135',
    K: { Value: 650, Unit: 'mm' },
    Aussenhoehe: { Value: 84, Unit: 'mm' },
    Biegeradius: { Value: 135, Unit: 'mm' },
    RastPosDist: { Value: 5, Unit: 'mm' },
    ArtNr: { DE: '400.20.135.0', US: '400-20-135-0' },
    UngeradeAnzahlGlieder: false,
    GleitenderBetriebErlaubt: true,
    Id: 14296,
    Innenhoehe: { Value: 56, Unit: 'mm' },
    VersatzFestpunktErlaubt: true,
    Bezeichnung: {
        'de-DE': 'e-kette® Serie 400',
        'hu-HU': 'E-Chains® 400 Széria',
        'en-US': 'Energy chain® Series 400',
        'zh-TW': '400系列拖鏈',
        'ko-KR': 'E-Chain® 400 시리즈',
        'es-ES': 'E-Chains® Serie 400',
        'zh-CN': '400系列拖链',
        'it-IT': 'Catena portacavi serie 400',
        'pl-PL': 'E-Chains® Seria 400',
        'nl-NL': 'Kabelrupsen Series 400',
        'pt-PT': 'Calhas articuladas da Série 400',
        'sv-SE': 'E-kedja serie 400',
        'da-DK': 'E-Kæde -serie 400',
        'cs-CZ': 'e-chain® série 400',
        'fr-FR': 'Chaîne Série 400',
        'en-GB': 'e-chain® Series 400',
        'ja-JP': 'エナジーチェーン 400型',
    },
};
/**
 * Creates 4000.20.2.1.A AE for Kette B17.
 */
exports.mockAe_4000_20_2_1_A = {
    ArtNr: { DE: '4000.20.2.1.A' },
    Mitnehmer: false,
    Id: 81180834400,
    Montiert: true,
    GliedAnzahlAbhaengig: 2,
    Festpunkt: true,
};
/**
 * Creates 4000.20.2.2.A AE for Kette B17.
 */
exports.mockAe_4000_20_2_2_A = {
    ArtNr: { DE: '4000.20.2.2.A' },
    Mitnehmer: true,
    Id: 84132044900,
    Montiert: true,
    GliedAnzahlAbhaengig: 2,
    Festpunkt: false,
};
/**
 * Creates a 413 vertical IA for Kette 400.
 */
exports.mockFlatIa_413 = {
    IAHKOLOH: { Value: 6.4, Unit: 'mm' },
    IAHKOROB: { Value: 0, Unit: 'mm' },
    ArtyConnect: '2600',
    IAHKBOT: { Value: 4.7, Unit: 'mm' },
    IAHKULOB: { Value: 0, Unit: 'mm' },
    IAHKULUH: { Value: 6.4, Unit: 'mm' },
    IAHKURUB: { Value: 0, Unit: 'mm' },
    Artikeltyp: 2300,
    IAHKOLUB: { Value: 0, Unit: 'mm' },
    IAHKULUB: { Value: 0, Unit: 'mm' },
    IAHKULOH: { Value: 0, Unit: 'mm' },
    IAHKUROB: { Value: 0, Unit: 'mm' },
    IAHKOLOB: { Value: 0, Unit: 'mm' },
    IAHKOLUH: { Value: 0, Unit: 'mm' },
    IAHKORUB: { Value: 0, Unit: 'mm' },
    IAHKULB: { Value: 0, Unit: 'mm' },
    IAHKURB: { Value: 0, Unit: 'mm' },
    IAHKOLB: { Value: 0, Unit: 'mm' },
    BestTyp: 300,
    IAHKRep: 7,
    IAHKDist: { Value: 7, Unit: 'mm' },
    IAHKORB: { Value: 0, Unit: 'mm' },
    Fussbreite: { Value: 8, Unit: 'mm' },
    IAHKH: { Value: 56, Unit: 'mm' },
    KetteSerieRef: [
        { Artikeltyp: 2300, Kuerzel: '400', Id: 14184 },
        { Artikeltyp: 2300, Kuerzel: '410', Id: 15088 },
        { Artikeltyp: 2300, Kuerzel: '880', Id: 15548 },
        { Artikeltyp: 2300, Kuerzel: '4040', Id: 15758 },
        { Artikeltyp: 2300, Kuerzel: '4140', Id: 16551 },
        { Artikeltyp: 2300, Kuerzel: '8840', Id: 17013 },
        { Artikeltyp: 2300, Kuerzel: '88', Id: 18488 },
        { Artikeltyp: 2300, Kuerzel: '14040', Id: 29208 },
        { Artikeltyp: 2300, Kuerzel: '14140', Id: 29908 },
        { Artikeltyp: 2300, Kuerzel: '18840', Id: 32388 },
        { Artikeltyp: 2300, Kuerzel: 'E4.56', Id: 40507 },
        { Artikeltyp: 2300, Kuerzel: 'H4.56', Id: 43367 },
        { Artikeltyp: 2300, Kuerzel: 'R4.56', Id: 44878 },
        { Artikeltyp: 2300, Kuerzel: '4040HD', Id: 50344 },
        { Artikeltyp: 2300, Kuerzel: '8840HD', Id: 50491 },
    ],
    ArtNr: { DE: '413', US: '413' },
    IAHKHeight: { Value: 4.5, Unit: 'mm' },
    Id: 635,
    KetteRef: [],
    Montiert: true,
    IAHKB: { Value: 8, Unit: 'mm' },
    Bezeichnung: {
        'de-DE': 'Teilungssteg, montiert',
        'hu-HU': 'Függőleges elválasztó, szerelt',
        'en-US': 'Vertical separator, assembled ',
        'zh-TW': '豎隔片，裝配件',
        'ko-KR': '수직 분리대, 조립',
        'es-ES': 'Divisor, montado',
        'zh-CN': '竖隔片，装配件',
        'it-IT': 'Separatore verticale, montato',
        'pl-PL': 'Zamontowany separator pionowy',
        'nl-NL': 'Verticale afscheiding, gemonteerd',
        'pt-PT': 'Separador vertical, montado',
        'sv-SE': 'Vertikal avdelare, monterad',
        'da-DK': 'Lodret separator, samlet',
        'cs-CZ': 'Vertikální oddělovač, sestavený',
        'fr-FR': 'Séparateur, monté',
        'en-GB': 'Middle plate, assembled',
        'ja-JP': 'ディバイダー、エナジーチェーンに組付',
    },
};
/**
 * Creates a 418 vertical IA for Kette 400.
 */
exports.mockFlatIa_418 = {
    IAHKOLOH: { Value: 5.6, Unit: 'mm' },
    IAHKOROB: { Value: 0, Unit: 'mm' },
    IAHKBOT: { Value: 4.7, Unit: 'mm' },
    ArtyIntersect: '2600|2510',
    IAHKULOB: { Value: 1.5, Unit: 'mm' },
    IAHKULUH: { Value: 5.6, Unit: 'mm' },
    IAHKURUB: { Value: 0, Unit: 'mm' },
    Artikeltyp: 2310,
    IAHKOLUB: { Value: 1.5, Unit: 'mm' },
    IAHKULUB: { Value: 0, Unit: 'mm' },
    IAHKULOH: { Value: 1.7, Unit: 'mm' },
    IAHKUROB: { Value: 1.5, Unit: 'mm' },
    IAHKOLOB: { Value: 0, Unit: 'mm' },
    IAHKOLUH: { Value: 1.7, Unit: 'mm' },
    IAHKORUB: { Value: 1.5, Unit: 'mm' },
    IAHKULB: { Value: 1.5, Unit: 'mm' },
    IAHKURB: { Value: 1.5, Unit: 'mm' },
    IAHKOLB: { Value: 1.5, Unit: 'mm' },
    BestTyp: 300,
    IAHKRep: 7,
    IAHKDist: { Value: 7, Unit: 'mm' },
    IAHKORB: { Value: 1.5, Unit: 'mm' },
    Fussbreite: { Value: 6, Unit: 'mm' },
    IAHKH: { Value: 56, Unit: 'mm' },
    KetteSerieRef: [
        { Artikeltyp: 2310, Kuerzel: '400', Id: 14184 },
        { Artikeltyp: 2310, Kuerzel: '410', Id: 15088 },
        { Artikeltyp: 2310, Kuerzel: '880', Id: 15548 },
        { Artikeltyp: 2310, Kuerzel: '4040', Id: 15758 },
        { Artikeltyp: 2310, Kuerzel: '4140', Id: 16551 },
        { Artikeltyp: 2310, Kuerzel: '8840', Id: 17013 },
        { Artikeltyp: 2310, Kuerzel: '88', Id: 18488 },
        { Artikeltyp: 2310, Kuerzel: '14040', Id: 29208 },
        { Artikeltyp: 2310, Kuerzel: '14140', Id: 29908 },
        { Artikeltyp: 2310, Kuerzel: '18840', Id: 32388 },
        { Artikeltyp: 2310, Kuerzel: 'E4.56', Id: 40507 },
        { Artikeltyp: 2310, Kuerzel: 'H4.56', Id: 43367 },
        { Artikeltyp: 2310, Kuerzel: 'R4.56', Id: 44878 },
        { Artikeltyp: 2310, Kuerzel: '4040HD', Id: 50344 },
        { Artikeltyp: 2310, Kuerzel: '8840HD', Id: 50491 },
    ],
    ArtNr: { DE: '418', US: '418' },
    IAHKHeight: { Value: 4.5, Unit: 'mm' },
    Id: 637,
    KetteRef: [],
    Montiert: true,
    IAHKB: { Value: 3, Unit: 'mm' },
    Bezeichnung: {
        'de-DE': 'Höhenschlitzsteg, montiert',
        'hu-HU': 'Hornyolt elválasztó, szerelt',
        'en-US': 'Slotted separator, assembled ',
        'zh-TW': '帶孔橫隔片支架，裝配件',
        'ko-KR': '슬롯형 분리대, 조립',
        'es-ES': 'Separador vertical ranurado, montado',
        'zh-CN': '带孔横隔片支架，装配件',
        'it-IT': 'Separatore forato, montato',
        'pl-PL': 'Zamontowany separator szczelinowy',
        'nl-NL': 'Scheidingsschot met sleuven, gemonteerd',
        'pt-PT': 'Separador ranhurado, montado',
        'sv-SE': 'Slitsad avdelare, monterad',
        'da-DK': 'Separator med slids, samlet',
        'cs-CZ': 'Drážkovaný oddělovač, sestavený',
        'fr-FR': 'Séparateur à fente ouvert, monté',
        'en-GB': 'Slotted separator, assembled',
        'ja-JP': 'スロットセパレーター、エナジーチェーンに組付',
    },
};
/**
 * Creates a 56.3.1 vertical IA for Kette 400.
 */
exports.mockFlatIa_56_3_1 = {
    IAHKOLOH: { Value: 6.8, Unit: 'mm' },
    IAHKOROB: { Value: 0, Unit: 'mm' },
    ArtyConnect: '2510',
    IAHKBOT: { Value: 11.5, Unit: 'mm' },
    ArtyIntersect: '2510',
    ArtNrConnect: '521.',
    IAHKULOB: { Value: 2, Unit: 'mm' },
    IAHKULUH: { Value: 6.8, Unit: 'mm' },
    IAHKURUB: { Value: 0, Unit: 'mm' },
    Artikeltyp: 2350,
    IAHKOLUB: { Value: 2, Unit: 'mm' },
    IAHKULUB: { Value: 0, Unit: 'mm' },
    IAHKULOH: { Value: 5.1, Unit: 'mm' },
    IAHKUROB: { Value: 2, Unit: 'mm' },
    IAHKOLOB: { Value: 0, Unit: 'mm' },
    IAHKOLUH: { Value: 5.1, Unit: 'mm' },
    IAHKORUB: { Value: 2, Unit: 'mm' },
    IAHKULB: { Value: 2, Unit: 'mm' },
    IAHKURB: { Value: 2, Unit: 'mm' },
    IAHKOLB: { Value: 2, Unit: 'mm' },
    BestTyp: 300,
    IAHKOLUH_Rounded: true,
    IAHKRep: 3,
    IAHKDist: { Value: 14, Unit: 'mm' },
    IAHKORB: { Value: 2, Unit: 'mm' },
    Fussbreite: { Value: 8, Unit: 'mm' },
    IAHKH: { Value: 55.4, Unit: 'mm' },
    KetteSerieRef: [
        { Artikeltyp: 2100, Kuerzel: '400', Id: 14184 },
        { Artikeltyp: 2100, Kuerzel: '410', Id: 15088 },
        { Artikeltyp: 2100, Kuerzel: '880', Id: 15548 },
        { Artikeltyp: 2100, Kuerzel: '4040', Id: 15758 },
        { Artikeltyp: 2100, Kuerzel: '4140', Id: 16551 },
        { Artikeltyp: 2100, Kuerzel: '8840', Id: 17013 },
        { Artikeltyp: 2100, Kuerzel: '14040', Id: 29208 },
        { Artikeltyp: 2100, Kuerzel: '14140', Id: 29908 },
        { Artikeltyp: 2100, Kuerzel: '18840', Id: 32388 },
        { Artikeltyp: 2100, Kuerzel: 'E4.56', Id: 40507 },
        { Artikeltyp: 2100, Kuerzel: 'H4.56', Id: 43367 },
        { Artikeltyp: 2100, Kuerzel: 'R4.56', Id: 44878 },
        { Artikeltyp: 2100, Kuerzel: '4040HD', Id: 50344 },
        { Artikeltyp: 2100, Kuerzel: '8840HD', Id: 50491 },
    ],
    ArtNr: { DE: '56.3.1', US: '56-3-1' },
    IAHKHeight: { Value: 4, Unit: 'mm' },
    IAHKULOH_Rounded: true,
    Id: 46826,
    KetteRef: [],
    Montiert: true,
    IAHKB: { Value: 4, Unit: 'mm' },
    Bezeichnung: {
        'de-DE': 'Trennsteg schmal, montiert',
        'hu-HU': 'Kis elválasztó, szerelt',
        'en-US': 'Separator small, assembled',
        'zh-TW': '小型分隔片，裝配件',
        'ko-KR': '소형 분리대, 조립',
        'es-ES': 'Separador grande, montado',
        'zh-CN': '小型分隔片，装配件',
        'it-IT': 'Separatore stretto montato',
        'pl-PL': 'Mały separator, zamontowany',
        'nl-NL': 'Scheidingsschot, klein, gemonteerd',
        'pt-PT': 'Separador pequeno, montado',
        'sv-SE': 'Avdelare smal, monterad',
        'da-DK': 'Lille separator, samlet',
        'cs-CZ': 'Dělicí příčka malá, sestavená',
        'fr-FR': 'Séparateur étroit, monté',
        'en-GB': 'Narrow separator, assembled',
        'ja-JP': 'セパレーター 巾狭、 取付済',
    },
};
/**
 * Creates a 421.50 horizontal IA for Kette 400.
 */
exports.mockZwischenbodenIa_421_50 = {
    Artikeltyp: 2600,
    KetteSerieRef: [
        { Artikeltyp: 2600, Kuerzel: '400', Id: 14184 },
        { Artikeltyp: 2600, Kuerzel: '410', Id: 15088 },
        { Artikeltyp: 2600, Kuerzel: '880', Id: 15548 },
        { Artikeltyp: 2600, Kuerzel: '4040', Id: 15758 },
        { Artikeltyp: 2600, Kuerzel: '4140', Id: 16551 },
        { Artikeltyp: 2600, Kuerzel: '8840', Id: 17013 },
        { Artikeltyp: 2600, Kuerzel: '88', Id: 18488 },
        { Artikeltyp: 2600, Kuerzel: '5050', Id: 20807 },
        { Artikeltyp: 2600, Kuerzel: '5150', Id: 21675 },
        { Artikeltyp: 2600, Kuerzel: '9850', Id: 22180 },
        { Artikeltyp: 2600, Kuerzel: '98', Id: 23735 },
        { Artikeltyp: 2600, Kuerzel: '600', Id: 25122 },
        { Artikeltyp: 2600, Kuerzel: '601', Id: 25300 },
        { Artikeltyp: 2600, Kuerzel: '608', Id: 25446 },
        { Artikeltyp: 2600, Kuerzel: '640', Id: 25524 },
        { Artikeltyp: 2600, Kuerzel: '1640', Id: 25977 },
        { Artikeltyp: 2600, Kuerzel: '1608', Id: 26398 },
        { Artikeltyp: 2600, Kuerzel: 'E6.80', Id: 27057 },
        { Artikeltyp: 2600, Kuerzel: '14040', Id: 29208 },
        { Artikeltyp: 2600, Kuerzel: '14140', Id: 29908 },
        { Artikeltyp: 2600, Kuerzel: '15050', Id: 31104 },
        { Artikeltyp: 2600, Kuerzel: '15150', Id: 31738 },
        { Artikeltyp: 2600, Kuerzel: 'E6.80L', Id: 32265 },
        { Artikeltyp: 2600, Kuerzel: '18840', Id: 32388 },
        { Artikeltyp: 2600, Kuerzel: '19850', Id: 32554 },
        { Artikeltyp: 2600, Kuerzel: 'E4.56', Id: 40507 },
        { Artikeltyp: 2600, Kuerzel: 'E4.80', Id: 41621 },
        { Artikeltyp: 2600, Kuerzel: 'H4.56', Id: 43367 },
        { Artikeltyp: 2600, Kuerzel: 'H4.80', Id: 43848 },
        { Artikeltyp: 2600, Kuerzel: 'R4.56', Id: 44878 },
        { Artikeltyp: 2600, Kuerzel: 'R4.80', Id: 46378 },
        { Artikeltyp: 2600, Kuerzel: '4040HD', Id: 50344 },
        { Artikeltyp: 2600, Kuerzel: '5050HD', Id: 50424 },
        { Artikeltyp: 2600, Kuerzel: '8840HD', Id: 50491 },
        { Artikeltyp: 2600, Kuerzel: '9850HD', Id: 50552 },
        { Artikeltyp: 2600, Kuerzel: 'E4.112', Id: 57869 },
        { Artikeltyp: 2600, Kuerzel: 'R4.112', Id: 57953 },
    ],
    BestTyp: 300,
    IAwmm: { Value: 50, Unit: 'mm' },
    ArtNr: { DE: '421.50', US: '421-50' },
    IAUebermass: { Value: 8, Unit: 'mm' },
    Breite: { Value: 50, Unit: 'mm' },
    IABodenH: { Value: 4.5, Unit: 'mm' },
    Id: 661,
    KetteRef: [],
    Montiert: true,
    Bezeichnung: {
        'de-DE': 'Zwischenboden, montiert',
        'hu-HU': 'Polc, szerelt',
        'en-US': 'Shelf, assembled ',
        'zh-TW': '支架，裝配件',
        'ko-KR': '가로분리대, 조립',
        'es-ES': 'Bandeja intermedia, montada',
        'zh-CN': '支架，装配件',
        'it-IT': 'Separatore orizzontale, montato',
        'pl-PL': 'Zamontowana półka',
        'nl-NL': 'Tussenschot, gemonteerd',
        'pt-PT': 'Travessa, montada',
        'sv-SE': 'Hylla, monterad',
        'da-DK': 'Hylde, samlet',
        'cs-CZ': 'Příčka, sestavená',
        'fr-FR': 'Fond encliquetable, monté',
        'en-GB': 'Shelf, assembled',
        'ja-JP': '棚板、エナジーチェーンに組付',
    },
};
/**
 * Creates a MAT0178542 Verpackung Trommel for Kette 400.
 */
exports.mockVerpackungTrommel_MAT0178542 = {
    EntityId: '1508954445089_947461',
    Id: 1805874262,
    ArtNr: { DE: 'MAT0178542' },
    ArtNrExists: true,
    ArtNrGenerated: 'MAT0178542',
    Bezeichnung: { 'de-DE': 'Trommel', 'en-GB': 'Drum', 'en-US': 'Drum' },
    Preis: { Countries: { DE: { EUR: 403.95 } } },
    Typ: VerpackungModel_1.VerpackungType.trommel,
    Verpackungsmittel: 'Trommel',
    Kerndurchmesser: { Unit: 'mm', Value: 455 },
    Innenbreite: { Unit: 'mm', Value: 700 },
    Flanschdurchmesser: { Unit: 'mm', Value: 1800 },
    Flanschstaerke: { Unit: 'mm', Value: 24 },
    TrommelbelastungMax: { Unit: 'kg', Value: 500 },
    Trommelkern: TrommelModel_1.Trommelkern.festpunkt,
    Waermebehandelt: true,
};
//# sourceMappingURL=mockArticles.js.map